import type { SimpleMenuItem } from "../MenuItems/SimpleMenuItems";
import { SimpleMenuItems } from "../MenuItems/SimpleMenuItems";
import { CustomMenu } from "./CustomMenu";
import type { MenuAnchorOrigin, MenuState } from "./CustomMenu";
export interface SimpleMenuProps {
    menuState: MenuState;
    items: SimpleMenuItem[];
    accessibleName: string;
    compact?: boolean;
    anchorOrigin?: MenuAnchorOrigin;
}
export function SimpleMenu({ menuState, items, accessibleName, compact, anchorOrigin }: SimpleMenuProps) {
    return (<CustomMenu menuState={menuState} accessibleName={accessibleName} anchorOrigin={anchorOrigin}>
            <SimpleMenuItems items={items} onClose={menuState.onClose} autoFocus={true} compact={compact}/>
        </CustomMenu>);
}
SimpleMenu.displayName = "SimpleMenu";
